if (!customElements.get("nss-counter")) {
    class NSSCounter extends HTMLElement {
        constructor() {
            super();

            this.counters = [];
            this.animationStarted = false;

            this.settings = {
                animationDuration: 2000,
                animationDelay: 100
            };

            this.options = {root: null, threshold: 0.2};
        }

        connectedCallback() {
            this.counters = this.querySelectorAll('.js-nss-countup');
            if (!this.counters.length) return;

            this.settings.animationDuration =
                parseInt(this.getAttribute('data-animation-duration')) || 2000;

            this.settings.animationDelay =
                parseInt(this.getAttribute('data-animation-delay')) || 100;

            if ('IntersectionObserver' in window) {
                this.observer = new IntersectionObserver(
                    this.onIntersection.bind(this),
                    this.options
                );
                this.observer.observe(this);
            } else {
                this.animateCounters();
            }
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }

        onIntersection(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.animationStarted) {
                    this.animationStarted = true;
                    this.animateCounters();
                    this.observer.disconnect();
                }
            });
        }

        animateCounters() {
            this.counters.forEach((counter, index) => {
                setTimeout(() => {
                    this.animateCounter(counter);
                }, index * this.settings.animationDelay);
            });
        }

        animateCounter(counter) {
            const rawValue = counter.getAttribute('data-countup-value');
            if (!rawValue) return;

            const isPercentage = rawValue.includes('%');
            const isDecimal = rawValue.includes('.');
            const hasCommas = rawValue.includes(',');

            const normalizedValue = rawValue.replace(/[–—−]/g, '-');
            let finalValue = parseFloat(normalizedValue.replace(/[^0-9.-]/g, ''));

            if (isNaN(finalValue) || finalValue < 0) {
                finalValue = Math.abs(finalValue);
            }

            if (isNaN(finalValue)) return;

            let prefix = '';
            let suffix = '';

            if (rawValue.trim().charAt(0).match(/[^0-9.-]/)) {
                prefix = rawValue.trim().charAt(0);
            }

            if (isPercentage) {
                suffix = '%';
            } else {
                const match = rawValue.match(/[^0-9.%]+$/);
                if (match) suffix = match[0];
            }

            const precision = isDecimal
                ? rawValue.split('.')[1].replace(/[^0-9]/g, '').length
                : 0;

            const startTime = performance.now();

            const animate = currentTime => {
                const elapsed = currentTime - startTime;
                let progress = Math.min(elapsed / this.settings.animationDuration, 1);
                progress = Math.min(Math.max(this.easeOutExpo(progress), 0), 1);

                const currentValue = progress * finalValue;
                let formattedValue = prefix;
                formattedValue += precision
                    ? currentValue.toFixed(precision)
                    : Math.floor(currentValue).toString();

                if (hasCommas) {
                    formattedValue = this.addCommas(formattedValue);
                }

                formattedValue += suffix;
                counter.textContent = formattedValue;

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    counter.textContent = rawValue;
                }
            };

            requestAnimationFrame(animate);
        }

        easeOutExpo(x) {
            return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
        }

        addCommas(value) {
            const parts = value.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        }
    }

    customElements.define('nss-counter', NSSCounter);
}
